import { useMemo } from 'react';

import cn from 'classnames';
import { AdminPermissions } from 'constants/admin-permissions';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import { selectAuthentication } from 'api/authentication-slice';

import styles from './AdminNavbar.module.scss';

const navigationItems = [
  {
    path: '/admin/users',
    label: 'Users',
    role: AdminPermissions.ListUsers,
  },
  {
    path: '/admin/companies',
    label: 'Companies',
    role: AdminPermissions.ListCompanies,
  },
  {
    path: '/admin/candidates',
    label: 'Candidates',
    role: AdminPermissions.ListCandidates,
  },
  {
    path: '/admin/checks',
    label: 'Candidate Checks',
    role: AdminPermissions.ListCandidateChecks,
  },
  {
    path: '/admin/dashboard',
    label: 'Dashboard',
    role: AdminPermissions.Dashboard,
  },
  {
    path: '/admin/check_types',
    label: 'Check Types',
    role: AdminPermissions.ListCheckTypes,
  },
  {
    path: '/admin/pricing',
    label: 'Pricing',
    role: AdminPermissions.ListPricing,
  },
  {
    path: '/admin/reporting',
    label: 'Reporting',
    role: AdminPermissions.Reporting,
  },
  {
    path: '/admin/admin_users',
    label: 'Admin Users',
    role: AdminPermissions.ListAdminUsers,
  },
  {
    path: '/admin/log',
    label: 'Logs',
    role: AdminPermissions.AdminLogs,
  },
  {
    path: '/admin/email_template_defaults',
    label: 'Email Defaults',
    role: AdminPermissions.UpdateEmailTemplates,
  },
];

export const AdminNavbar = () => {
  const authentication = useSelector(selectAuthentication);

  const allowedAdminTabs = useMemo(() => {
    if (!authentication.checked) return [];

    return navigationItems.filter(item => authentication.admin_permissions?.includes(item.role));
  }, [authentication.checked, authentication.admin_permissions]);

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <Link to="/dashboard" className={styles.logo}>
          <img
            className={cn(styles.logo, 'u-margin-bottom--0')}
            src="./assets/images/checkmate/icon-label.svg"
            alt="checkmate"
          />
        </Link>
        <div className={cn(styles.hideXS, styles.links)}>
          {allowedAdminTabs.map(item => (
            <NavLink key={item.path} to={item.path}>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};
